<strong> &copy; {{ currentYear }} {{ 'brand' | transloco }} </strong>
<div class="grid grid-cols-2 md:flex md:gap-14">
  @for (link of links; track $index) {
    <rma-footer-link class="py-2 md:py-0" [footerLink]="link" />
  }
</div>
